import { htmlToText } from '@ui/helpers/htmlToText';

export const htmlToTiptapText = (html) => htmlToText(html
  .replace(/<div data-nudge-count=[^>]+><\/div>/g, '')
  // remove nudge wrapper: <div data-nudge-id...><p></p></div> => <p></p>
  // so it doesn't affect highlight positions
  .replace(/<div data-nudge-id[^>]+>(.*?)<\/div>/g, '$1')
  .replaceAll('</div></li>', '\n\n</li>')
  .replaceAll('</div><ul>', '\n\n<ul>'));
